module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello text-center"
  }, [_c('div', {
    staticClass: "error-bg"
  }), _vm._v(" "), (_vm.code) ? _c('div', {
    staticClass: "error-code"
  }, [_vm._v(_vm._s(_vm.code))]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_c('a', {
    staticClass: "return-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.goKKPage($event)
      }
    }
  }, [_vm._v("返回施小慧")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b8ff72c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Error.vue
// module id = 146
// module chunks = 1 2